import { useForm } from "react-hook-form";
import { z } from "zod";
import { MiDetailFields, MiModal } from "@miplatform/components";
import {
  BUTTON_COLORS,
  BUTTON_VARIANTS,
  TYPOGRAPHY_VARIANTS,
} from "@miplatform/constants";
import { zodResolver } from "@hookform/resolvers/zod";
import { mdiCancel } from "@mdi/js";
import { Typography, useTheme } from "@mui/material";

export const CancelOrderModal = ({ open, onClose, onCancel, isLoading }) => {
  const theme = useTheme();

  const {
    control,
    handleSubmit,
    formState: { isValid, isDirty },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      reason: "",
    },
    resolver: zodResolver(
      z.object({
        reason: z.string().min(1, "Cancel Reason is required."),
      })
    ),
  });
  const cancelModalFields = [
    {
      label: "Cancel Reason",
      name: "reason",
      required: true,
      formControl: control,
    },
  ];

  const handleFormSubmit = async (data) => {
    await onCancel(data);
  };

  return (
    <MiModal
      open={open}
      closeModal={onClose}
      width={330}
      titleIcon={mdiCancel}
      leftIconColor={theme.palette.red.main}
      title="Cancel Order"
      loading={isLoading}
      actions={[
        {
          name: "Close",
          variant: BUTTON_VARIANTS.TEXT,
          color: BUTTON_COLORS.BLACK,
          onClick: onClose,
        },
        {
          name: "Cancel Order",
          color: BUTTON_COLORS.RED,
          variant: BUTTON_VARIANTS.CONTAINED,
          disabled: !isValid || !isDirty || isLoading,
          onClick: handleSubmit(handleFormSubmit),
        },
      ]}
    >
      <Typography
        variant={TYPOGRAPHY_VARIANTS.SUBTITLE2}
        color="grey"
        mb={2}
        px={2}
      >
        Cancelling an order will cancel all assignments which have been
        generated. A record of this order will be maintained within home details
      </Typography>
      <MiDetailFields detailFields={cancelModalFields} />
    </MiModal>
  );
};
